var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainButtonBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 47,
    viewBox: "0 0 82 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3608:5764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.5 47V8L81.5 17L78.5 21.5L78 36L61.5 33.5L55.5 45.5L42.5 40.5L29 45L15.5 39L8.5 47H82.5Z",
    fill: "url(#paint0_radial_3608:5764)",
    fillOpacity: 0.15
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 39V15L80.923 20.0464C80.3484 21.8851 78.8714 23.301 77.01 23.7973C74.3959 24.4944 72.6505 26.9564 72.858 29.6539L73.0438 32.0698C73.4909 37.8818 67.7715 42.2053 62.3018 40.1901L59.114 39.0157C56.6061 38.0917 53.7897 38.7103 51.8998 40.6002C50.3876 42.1124 48.2561 42.8319 46.1368 42.5455L34.2487 40.939C32.1669 40.6577 30.058 41.2065 28.3774 42.467L27.494 43.1295C25.8901 44.3324 23.8929 44.8893 21.898 44.6898L11.7648 43.6765C10.6024 43.5602 9.42861 43.7 8.32597 44.0859L0 47H74.5C78.9183 47 82.5 43.4183 82.5 39Z",
    fill: "url(#paint1_radial_3608:5764)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 39V12L79.4491 20.7168C79.1518 21.5662 79 22.4596 79 23.3596V24.3234C79 28.1897 76.235 31.5027 72.4311 32.1943L71.5966 32.3461C69.3125 32.7614 67.3214 34.1485 66.1403 36.1472L65.2281 37.691C63.1184 41.2612 58.6302 42.6275 54.889 40.8382L53.8798 40.3556C51.4572 39.1969 48.6149 39.3311 46.3122 40.7127L42.4356 43.0387C40.86 43.984 39.0071 44.3582 37.1882 44.0983L25.0647 42.3664C23.3975 42.1282 21.6977 42.4223 20.2074 43.2066L13 47H74.5C78.9183 47 82.5 43.4183 82.5 39Z",
    fill: "url(#paint2_radial_3608:5764)",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 39V8L81.715 15.0654C81.5737 16.3366 81.1297 17.5554 80.4203 18.6196L79.7605 19.6092C78.9365 20.8453 78.4729 22.2864 78.4217 23.7711L78.3097 27.0199C78.1448 31.8019 73.8469 35.3707 69.116 34.6539L67.2521 34.3715C63.8228 33.8519 60.4494 35.6013 58.8982 38.7035L58.7482 39.0036C56.9058 42.6885 52.5661 44.3716 48.7209 42.8927L45.1788 41.5303C43.447 40.8642 41.5375 40.8208 39.7772 41.4076L31.6696 44.1101C29.9417 44.6861 28.0691 44.6552 26.3612 44.0227L20.3091 41.7811C17.3783 40.6957 14.0837 41.4163 11.8737 43.6263L8.5 47H74.5C78.9183 47 82.5 43.4183 82.5 39Z",
    fill: "url(#paint3_radial_3608:5764)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3608:5764",
    x: 0.5,
    y: 0,
    width: 90,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_3608:5764"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3608:5764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2754 15.4303) rotate(24.0906) scale(60.967 46.0516)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.409121,
    stopColor: "#01E5F4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DDF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3608:5764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.3851 47) rotate(180) scale(143.26 43.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D8E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3608:5764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.5608 47) rotate(180) scale(120.686 47.6755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D8E5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3608:5764",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.5 47) rotate(180) scale(128.5 53.1241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36D8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36D8E5",
    stopOpacity: 0
  })))));
}
export default SvgMainButtonBackground;